import { create } from 'zustand';

import { DEFAULT_MOBILE_ALERT_TOP_OFFSET } from '../../utils/constants';

export const IS_INBOX_SECTION_OPEN = 'isInboxSectionOpen';

function readSessionStorageInboxSectionOpen(): boolean {
  if (typeof window === 'undefined') {
    return false;
  }
  try {
    const stored = sessionStorage.getItem(IS_INBOX_SECTION_OPEN);
    return stored ? (JSON.parse(stored) as boolean) : false;
  } catch {
    return false;
  }
}

function writeSessionStorageInboxSectionOpen(value: boolean): void {
  sessionStorage.setItem(IS_INBOX_SECTION_OPEN, JSON.stringify(value));
}

interface SidebarStore {
  mobileAlertTopOffset: number;
  setMobileAlertTopOffset: (offset: number) => void;
  isInboxSectionOpen: boolean;
  toggleInboxSection: () => void;
}

export const useSidebarStore = create<SidebarStore>((set) => ({
  mobileAlertTopOffset: DEFAULT_MOBILE_ALERT_TOP_OFFSET,
  setMobileAlertTopOffset: (offset) => set({ mobileAlertTopOffset: offset }),
  isInboxSectionOpen: readSessionStorageInboxSectionOpen(),
  toggleInboxSection: () =>
    set((s) => {
      const next = !s.isInboxSectionOpen;
      writeSessionStorageInboxSectionOpen(next);
      return { isInboxSectionOpen: next };
    }),
}));
